import firebase from 'firebase'

firebase.initializeApp({
    apiKey: "AIzaSyAkEF7yocrtYBduL0Yl8Oy9tMPrhNVMmSw",
    authDomain: "signin-trading.firebaseapp.com",
    databaseURL: "https://signin-trading.firebaseio.com",
    projectId: "signin-trading",
    storageBucket: "signin-trading.appspot.com",
    messagingSenderId: "536355339776",
    appId: "1:536355339776:web:24fc4897aded16db9c22e5",
    measurementId: "G-5JEKXFB7YS"
});

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;
export const firebaseInstance = firebase;

// Guard messaging init — firebase.messaging() throws synchronously on
// browsers that don't support the required APIs (notably iOS Safari,
// and Chrome on iOS since it also uses Safari's engine). Since this file
// is imported at the very top of the app, an unguarded throw here used
// to crash the entire app before React ever rendered anything.
export let firebaseMessaging = null;
try {
  if (firebase.messaging.isSupported()) {
    firebaseMessaging = firebase.messaging();
  } else {
    console.warn('Firebase Messaging is not supported in this browser.');
  }
} catch (error) {
  console.warn('Firebase Messaging failed to initialize:', error);
}